(function () {
  angular.module('binky.core.insights.access', ['binky.core.insights.item']);
})();
